/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Fix logging settings DTO
 */
export interface FixLoggingSettingDto {
  id: number;
  service: string;
  senderCompId: string;
  targetCompId: string;
  logIncoming: boolean;
  logOutgoing: boolean;
  logIntoOneFile: boolean;
  logHeartbeats: boolean;
}
